import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select as ChakraSelect, createListCollection, Portal } from "@chakra-ui/react";
import { Check, NavArrowDown } from "iconoir-react";
export const Select = ({ options, placeholder, name, onValueChange, onOpenChange, onFocusOutside, colorPalette, portalled = true, ...chakraProps }) => {
    const collection = createListCollection({
        items: options,
    });
    const handleValueChange = (details) => {
        onValueChange?.(details);
    };
    const handleOpenChange = (details) => {
        onOpenChange?.(details);
    };
    const handleFocusOutside = () => {
        onFocusOutside?.();
    };
    return (_jsxs(ChakraSelect.Root, { ...chakraProps, collection: collection, onValueChange: handleValueChange, onOpenChange: handleOpenChange, onFocusOutside: handleFocusOutside, colorPalette: colorPalette, children: [_jsx(ChakraSelect.HiddenSelect, { name: name }), _jsxs(ChakraSelect.Control, { children: [_jsx(ChakraSelect.Trigger, { children: _jsx(ChakraSelect.ValueText, { placeholder: placeholder }) }), _jsx(ChakraSelect.IndicatorGroup, { children: _jsx(NavArrowDown, { width: 16, height: 16 }) })] }), _jsx(Portal, { disabled: !portalled, children: _jsx(ChakraSelect.Positioner, { children: _jsx(ChakraSelect.Content, { children: collection.items.map((option) => (_jsxs(ChakraSelect.Item, { item: option, children: [_jsx(ChakraSelect.ItemText, { children: option.label }), _jsx(ChakraSelect.ItemIndicator, { children: _jsx(Check, { width: 16, height: 16 }) })] }, option.value))) }) }) })] }));
};
